var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 266 48",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("path", {
          attrs: {
            id: "leapsigh-isologo@3x_svg__a",
            d: "M.094.822h22.328V33H.094z"
          }
        }),
        _c("path", {
          attrs: {
            id: "leapsigh-isologo@3x_svg__c",
            d: "M.094-.003h15.954V32.13H.094z"
          }
        }),
        _c("path", {
          attrs: {
            id: "leapsigh-isologo@3x_svg__e",
            d: "M0 .166h35.07v38.89H0z"
          }
        }),
        _c("path", {
          attrs: {
            id: "leapsigh-isologo@3x_svg__g",
            d: "M.615.456H27.78v46.6H.615z"
          }
        }),
        _c("path", {
          attrs: {
            id: "leapsigh-isologo@3x_svg__i",
            d: "M0 .456h15.952v30.72H0z"
          }
        })
      ]),
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", {
          attrs: {
            d:
              "M68.294 37.472c-.89-.802-1.337-1.991-1.337-3.566V8.28c0-.475.171-.892.513-1.248a1.687 1.687 0 011.27-.534c.505 0 .928.178 1.27.534.342.356.512.773.512 1.248v25.047c0 .743.097 1.278.29 1.605.193.327.572.49 1.137.49h.356c1.25-.06 1.947.312 2.096 1.114a2.5 2.5 0 01.043.534c0 .327-.066.617-.2.87a1.03 1.03 0 01-.557.512c-.445.148-1.069.223-1.872.223-1.456 0-2.629-.401-3.52-1.203M97.816 24.68c-.12-1.93-.819-3.386-2.094-4.367-1.278-.98-3.032-1.47-5.26-1.47-2.496 0-4.36.467-5.594 1.403-1.233.936-1.983 2.414-2.25 4.434h15.198zm3.186 2.385c-.341.342-.765.512-1.27.512H82.483c.09 2.615.794 4.546 2.117 5.794 1.322 1.248 3.35 1.872 6.085 1.872 1.811 0 3.267-.252 4.366-.758 1.1-.505 1.945-1.307 2.54-2.406.475-.624.966-.937 1.472-.937.297 0 .594.09.89.268.268.15.476.35.625.602.148.253.223.512.223.78 0 .356-.12.698-.357 1.025-1.664 3.298-4.947 4.947-9.85 4.947-3.773 0-6.662-1.01-8.668-3.03-2.006-2.02-3.008-4.904-3.008-8.647 0-3.892.943-6.803 2.83-8.735 1.886-1.93 4.76-2.897 8.625-2.897 3.416 0 6.067.877 7.954 2.63 1.886 1.753 2.933 4.323 3.142 7.71.03.505-.126.93-.468 1.27zM125.198 30.787v-7.31c-.891-3.06-3.386-4.59-7.487-4.59-2.704 0-4.695.669-5.972 2.006-1.278 1.336-1.917 3.417-1.917 6.239 0 2.734.647 4.769 1.939 6.106 1.293 1.337 3.276 2.006 5.95 2.006 4.159 0 6.655-1.486 7.487-4.457m3.031-14.485c.326.357.49.773.49 1.248v19.387c0 .505-.164.936-.49 1.292-.328.357-.743.535-1.248.535-.535 0-.966-.178-1.292-.535a1.838 1.838 0 01-.491-1.292v-2.228a8.97 8.97 0 01-3.141 2.919c-1.293.727-2.846 1.09-4.658 1.09-3.595 0-6.329-.993-8.2-2.984-1.873-1.99-2.808-4.872-2.808-8.646 0-3.773.935-6.656 2.808-8.646 1.871-1.991 4.605-2.986 8.2-2.986 1.693 0 3.216.372 4.568 1.114 1.352.742 2.429 1.723 3.231 2.94v-1.96c0-.475.171-.891.513-1.248a1.688 1.688 0 011.27-.535c.505 0 .92.179 1.248.535M152.45 33.193c1.293-1.337 1.94-3.371 1.94-6.106 0-2.822-.64-4.894-1.917-6.217-1.278-1.322-3.283-1.983-6.017-1.983-4.1 0-6.581 1.515-7.442 4.546v7.264c.86 3.002 3.342 4.502 7.442 4.502 2.704 0 4.703-.669 5.995-2.006m2.54-14.752c1.887 1.991 2.83 4.873 2.83 8.646 0 3.743-.943 6.603-2.83 8.579-1.887 1.977-4.628 2.965-8.223 2.965-1.812 0-3.357-.357-4.634-1.071a8.825 8.825 0 01-3.12-2.896v11.008c0 .505-.164.936-.49 1.293-.327.356-.758.534-1.293.534-.505 0-.93-.178-1.27-.534a1.8 1.8 0 01-.512-1.293v-28.39c0-.475.17-.891.512-1.248a1.69 1.69 0 011.27-.535c.505 0 .928.179 1.27.535.34.357.513.773.513 1.248v2.229c.772-1.218 1.834-2.199 3.187-2.941 1.35-.743 2.874-1.114 4.567-1.114 3.595 0 6.336.994 8.223 2.985M166.91 38.207a11.03 11.03 0 01-3.5-1.493c-.445-.297-.668-.742-.668-1.337 0-.386.118-.743.356-1.07.357-.445.803-.67 1.338-.67.415 0 .786.107 1.114.314 1.485.89 3.371 1.337 5.66 1.337 1.663 0 2.941-.282 3.833-.846.89-.565 1.337-1.367 1.337-2.408 0-.98-.447-1.797-1.337-2.451-.892-.653-2.303-1.174-4.234-1.56-2.615-.474-4.56-1.218-5.839-2.228-1.278-1.01-1.916-2.347-1.916-4.011 0-2.021.69-3.588 2.072-4.702 1.381-1.114 3.305-1.671 5.771-1.671 1.338 0 2.645.163 3.922.49 1.277.327 2.363.802 3.254 1.426.416.297.624.729.624 1.292 0 .476-.149.863-.446 1.159-.357.357-.742.535-1.159.535-.445 0-.862-.133-1.247-.401a6.458 6.458 0 00-1.96-.891c-.685-.18-1.547-.267-2.586-.267-1.694 0-2.905.245-3.633.735-.728.49-1.09 1.24-1.09 2.25 0 .744.362 1.353 1.09 1.827.728.476 2.057.908 3.99 1.293 2.821.565 4.901 1.426 6.238 2.585 1.338 1.158 2.006 2.719 2.006 4.68 0 2.139-.772 3.765-2.317 4.879-1.545 1.115-3.789 1.672-6.73 1.672-1.337 0-2.652-.156-3.944-.468M187.558 11.11c-.446-.46-.67-1.092-.67-1.894 0-.832.216-1.463.648-1.894.43-.43 1.062-.646 1.894-.646.86 0 1.515.216 1.96.646.447.43.669 1.062.669 1.894 0 .802-.231 1.434-.691 1.894-.461.46-1.107.69-1.938.69-.803 0-1.427-.23-1.872-.69m3.52 5.616c.208.342.313.706.313 1.09v19.032c0 .506-.163.936-.49 1.292-.327.357-.758.535-1.293.535-.535 0-.966-.178-1.293-.535a1.84 1.84 0 01-.49-1.292V19.422h-1.515a1.67 1.67 0 01-1.225-.513 1.67 1.67 0 01-.513-1.225c0-.505.17-.921.513-1.248.34-.327.75-.49 1.225-.49h3.342c.149 0 .342.03.58.088.356.12.639.35.846.692",
            fill: "#617887"
          }
        }),
        _c("g", { attrs: { transform: "translate(197 14.544)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-isologo@3x_svg__b", fill: "#fff" } },
            [
              _c("use", {
                attrs: { "xlink:href": "#leapsigh-isologo@3x_svg__a" }
              })
            ]
          ),
          _c("path", {
            attrs: {
              d:
                "M18.901 16.153V8.844c-.89-3.03-3.386-4.546-7.487-4.546-2.734 0-4.732.662-5.994 1.983-1.263 1.323-1.895 3.395-1.895 6.217 0 2.735.647 4.777 1.94 6.128 1.292 1.353 3.275 2.028 5.95 2.028 4.13 0 6.624-1.499 7.486-4.5m3.031-14.708c.326.356.49.787.49 1.292v16.268c0 4.782-.913 8.311-2.74 10.584-1.828 2.273-4.836 3.41-9.026 3.41-1.308 0-2.629-.119-3.966-.357-1.337-.238-2.48-.579-3.432-1.025-.654-.328-.98-.818-.98-1.47 0-.268.058-.52.178-.758.118-.298.312-.528.58-.69.266-.165.564-.246.891-.246.237 0 .49.044.757.133.772.297 1.71.542 2.808.736 1.1.193 2.14.29 3.12.29 2.793 0 4.836-.75 6.128-2.25 1.293-1.502 2.012-3.93 2.161-7.288a9.377 9.377 0 01-3.186 2.92c-1.293.727-2.83 1.091-4.613 1.091-3.595 0-6.329-.995-8.2-2.986C1.03 19.11.094 16.228.094 12.454c0-3.773.935-6.656 2.808-8.646 1.871-1.99 4.605-2.986 8.2-2.986 1.693 0 3.216.372 4.568 1.114 1.352.742 2.43 1.723 3.231 2.941V2.738c0-.505.163-.936.491-1.292.326-.357.757-.535 1.292-.535.505 0 .92.178 1.248.535",
              fill: "#617887",
              mask: "url(#leapsigh-isologo@3x_svg__b)"
            }
          })
        ]),
        _c("path", {
          attrs: {
            d:
              "M244.246 18.262c1.455 1.872 2.184 4.665 2.184 8.38v10.25c0 .505-.163.93-.49 1.27-.327.342-.758.512-1.292.512-.506 0-.922-.17-1.25-.512-.326-.34-.49-.765-.49-1.27v-9.894c0-2.853-.445-4.903-1.336-6.15-.891-1.248-2.422-1.872-4.591-1.872-2.288 0-4.048.78-5.281 2.34-1.233 1.56-1.894 3.795-1.983 6.707v8.824c0 .506-.164.936-.49 1.292-.327.357-.757.535-1.293.535-.505 0-.93-.178-1.27-.535a1.795 1.795 0 01-.512-1.292V8.234c0-.505.17-.92.512-1.247.34-.327.765-.49 1.27-.49.536 0 .966.163 1.293.49.326.327.49.742.49 1.247v12.568c.772-1.693 1.812-3.008 3.12-3.944 1.307-.935 2.852-1.403 4.634-1.403 3.06 0 5.319.935 6.775 2.807",
            fill: "#617887"
          }
        }),
        _c("g", { attrs: { transform: "translate(249 6.544)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-isologo@3x_svg__d", fill: "#fff" } },
            [
              _c("use", {
                attrs: { "xlink:href": "#leapsigh-isologo@3x_svg__c" }
              })
            ]
          ),
          _c("path", {
            attrs: {
              d:
                "M15.648 28.877c.267.327.4.7.4 1.114 0 .714-.252 1.25-.757 1.604a2.798 2.798 0 01-1.65.535h-.578c-2.2 0-3.945-.564-5.237-1.694-1.292-1.128-1.938-2.763-1.938-4.902v-12.88H1.832c-.505 0-.922-.155-1.248-.467-.328-.312-.49-.706-.49-1.182 0-.475.162-.86.49-1.159.326-.296.743-.445 1.248-.445h4.056v-7.62c0-.476.17-.893.512-1.249.34-.356.78-.535 1.315-.535.534 0 .98.18 1.337.535.356.356.535.773.535 1.248v7.621h4.59c.475 0 .877.15 1.204.445.326.298.49.684.49 1.16 0 .475-.164.87-.49 1.181a1.678 1.678 0 01-1.204.467h-4.59V22.95c0 1.398.08 2.482.245 3.254.163.773.497 1.36 1.002 1.76.505.402 1.278.602 2.318.602.238 0 .49-.029.758-.09a3.27 3.27 0 01.669-.088c.445 0 .802.163 1.069.49",
              fill: "#617887",
              mask: "url(#leapsigh-isologo@3x_svg__d)"
            }
          })
        ]),
        _c("g", { attrs: { transform: "translate(0 7.544)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-isologo@3x_svg__f", fill: "#fff" } },
            [
              _c("use", {
                attrs: { "xlink:href": "#leapsigh-isologo@3x_svg__e" }
              })
            ]
          ),
          _c("path", {
            attrs: {
              d:
                "M19.579 31.347h-.114c-6.482 0-11.755-5.273-11.755-11.755V.166H0v19.426c0 10.733 8.732 19.464 19.465 19.464H35.07v-7.71H19.579z",
              fill: "#FBAE17",
              mask: "url(#leapsigh-isologo@3x_svg__f)"
            }
          })
        ]),
        _c("path", {
          attrs: {
            d:
              "M35.07 23.335H19.466c-1.35 0-2.642-.24-3.85-.66v4.46c0 1.225.119 2.423.337 3.586 1.14.21 2.313.323 3.513.323H42.78v-7.709h-7.71z",
            fill: "#75CDDC"
          }
        }),
        _c("g", { attrs: { transform: "translate(15 -.456)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-isologo@3x_svg__h", fill: "#fff" } },
            [
              _c("use", {
                attrs: { "xlink:href": "#leapsigh-isologo@3x_svg__g" }
              })
            ]
          ),
          _c("path", {
            attrs: {
              d:
                "M20.07 31.5v7.847h.01-.01c-5.105-.004-9.448-3.286-11.063-7.846a11.674 11.674 0 01-.682-3.91V.457H.615V27.59c0 1.226.119 2.423.337 3.586a19.373 19.373 0 003.627 8.17c3.556 4.678 9.176 7.706 15.492 7.709H27.78V31.5h-7.71z",
              fill: "#2CA2B5",
              mask: "url(#leapsigh-isologo@3x_svg__h)"
            }
          })
        ]),
        _c("g", { attrs: { transform: "translate(0 -.456)" } }, [
          _c(
            "mask",
            { attrs: { id: "leapsigh-isologo@3x_svg__j", fill: "#fff" } },
            [
              _c("use", {
                attrs: { "xlink:href": "#leapsigh-isologo@3x_svg__i" }
              })
            ]
          ),
          _c("path", {
            attrs: {
              d:
                "M15.615 27.592V23.13c-4.594-1.6-7.906-5.962-7.906-11.094V8.166h7.906V.456H0v11.58c0 6.32 3.03 11.943 7.71 15.5a19.364 19.364 0 008.242 3.64 19.435 19.435 0 01-.337-3.584",
              fill: "#F37C20",
              mask: "url(#leapsigh-isologo@3x_svg__j)"
            }
          })
        ]),
        _c("path", {
          attrs: {
            d: "M7.71 27.081V7.709H0v3.871c0 6.32 3.03 11.943 7.71 15.501",
            fill: "#DD5A26"
          }
        }),
        _c("path", {
          attrs: {
            d: "M35.07 46.6v-7.71H19.58c3.556 4.679 9.176 7.707 15.492 7.71",
            fill: "#298594"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M15.615 22.675v4.46c0 1.226.12 2.423.337 3.586 1.14.209 2.313.324 3.512.324h4.543a11.674 11.674 0 01-.683-3.91v-3.8h-3.86c-1.349 0-2.64-.24-3.849-.66",
            fill: "#3A595E"
          }
        }),
        _c("path", {
          attrs: { d: "M35.07 46.6h.01-.01M35.07 38.89h.01-.01z", fill: "#000" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }